














import {IGrabSchedule} from '@/interfaces/server-data';
import Http from '@/mixins/http';
import LocalData from '@/mixins/local-data';
import {Component, Mixins, Prop} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class GrabbingSchedule extends Mixins(LocalData, Http) {
    @Prop() readonly value!: IGrabSchedule;
}
